import {
  TablePagination,
  Table,
  TableRow,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  Box,
  makeStyles,
  Typography,
  ButtonGroup,
  InputBase,
  withStyles,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  Grid,
  Snackbar,
  CircularProgress,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormLabel,
  TextField,
  NativeSelect
} from "@material-ui/core";
import { useEffect, useState } from 'react'
import { FetchCoachList, UpdateCoachStatus } from './apis/api';

let headers = [
  "First Name",
  "Last Name",
  "email",
  "type",
  "status",
  "Action"
];

const rowData = [
  {
    firstName: "Hammad",
    lastName: "Asad",
    email: "hammad.asad444@gmail.com",
    type: "COACH",
    coachStatus: "PENDING"
  },
];

const useStyles = makeStyles((theme) => ({
  root: {
    position: "relative",
  },
  table: {
    minWidth: 1050,
  },
  tableHeadCell: {
    fontSize: "18px",
  },
  tableRowCell: {
    fontSize: "14px",
    borderBottom: "none",
    lineHeight: "40px",
    align: "left",
  },
  dropdown: {
    position: "absolute",
    top: 28,
    right: 0,
    left: 0,
    zIndex: 1,
    border: "1px solid",
    padding: theme.spacing(1),
    backgroundColor: theme.palette.background.paper,
  },
  search: {
    position: "relative",
    borderRadius: theme.shape.borderRadius,
    backgroundColor: "#f2f2f2",
    marginRight: theme.spacing(2),
    marginLeft: 0,
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      marginLeft: theme.spacing(3),
      width: "auto",
    },
  },
  searchIcon: {
    padding: theme.spacing(0, 2),
    height: "100%",
    position: "absolute",
    pointerEvents: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  inputRoot: {
    color: "inherit",
    fontSize: "14px",
  },
  inputInput: {
    padding: theme.spacing(1.5, 1.5, 1.5, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
    transition: theme.transitions.create("width"),
    width: "100%",
    [theme.breakpoints.up("md")]: {
      width: "40ch",
    },
  },
}));

const StyledTableRow = withStyles((theme) => ({
  root: {
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
    },
  },
}))(TableRow);
// end of css
export function RequestPage() {
  const classes = useStyles();

  const [coachesList, setCoachesList] = useState([]);
  const [pending, setPending] = useState(false);

  const [btnPending, setBtnPending] = useState(false)

  const [snack, setSnack] = useState(()=>({
    message: '',
    open: false
  }))

  const [filter, setFilter] = useState('PENDING')

  const fetchCoaches = async (status) => {
    setPending(true);
    // console.log(status);
    let coaches = await FetchCoachList(status);
    setCoachesList(coaches.data.users);
    setPending(false);
  }

  const handleUpdateSatus = async (id, status) => {
    setBtnPending(true);
    let coaches = await UpdateCoachStatus(id, status);
    setSnack((pre)=>({
      ...pre,
      open: true,
      message: coaches.data.message
    }));
    setBtnPending(false);
    fetchCoaches(filter);
  }
  

  // useEffect(()=>{
  //   fetchCoaches()
  // },[])

  useEffect(()=>{
    // console.log(filter);
    fetchCoaches(filter)
  }, [filter])

  return (
    <div>
      <Snackbar
        open={snack.open}
        autoHideDuration={2000}
        message={snack.message}
        onClose={()=>{
          setSnack(()=>({
            open: false,
            message: ""
          }))
        }}
      />
      <div className="col-sm-12 mb-5 d-flex justify-content-between">
        <Typography variant="h4" className="font-weight-bold">
          Requests
        </Typography>
        <div>
          <FormControl sx={{ m: 1, minWidth: 300 }}>
            <InputLabel id="demo-select-small">Filter</InputLabel>
            <Select
              labelId="demo-select-small"
              id="demo-select-small"
              value={filter}
              label="Filter"
              onChange={(e)=>setFilter(e.target.value)}
            >
              <MenuItem value={'PENDING'}>PENDING</MenuItem>
              <MenuItem value={'BLOCKED'}>BLOCKED</MenuItem>
            </Select>
          </FormControl>
          {/* <InputLabel variant="standard" htmlFor="uncontrolled-native">
            Filter
          </InputLabel>
          <NativeSelect
            defaultValue={30}
            inputProps={{
              name: 'age',
              id: 'uncontrolled-native',
            }}
          >
            <option value={'PENDING'}>PENDING</option>
            <option value={'BLOCKED'}>BLOCKED</option>
          </NativeSelect> */}
        </div>
      </div>
      <TableContainer className="mt-10">
        <Table className={classes.table} aria-label="simple table">
          <TableHead>
            <TableRow>
              {headers.map((item, index) => (
                <TableCell
                  key={index}
                  align="left"
                  classes={{ root: classes.tableHeadCell }}
                >
                  {item}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          {!pending ? 
            coachesList.length == 0 ?
            <TableBody>
              <TableCell align="center" colSpan={6}>
                {"No Requests available"}
              </TableCell>
            </TableBody>
            
            :
            <TableBody>
            {coachesList.map((row, index) => (
              <StyledTableRow key={index}>
                <TableCell
                  classes={{
                    root: classes.tableRowCell,
                  }}
                  component="th"
                  scope="row"
                  align="left"
                  // onClick={() => openUserDetails(row)}
                >
                  {row.firstName}
                </TableCell>
                <TableCell
                  align="left"
                  classes={{ root: classes.tableRowCell }}
                >
                  {row.lastName}
                </TableCell>
                <TableCell
                  align="left"
                  classes={{ root: classes.tableRowCell }}
                >
                  {row.email}
                </TableCell>
                <TableCell
                  align="left"
                  classes={{ root: classes.tableRowCell }}
                >
                  {row.type}
                </TableCell>
                <TableCell
                  align="left"
                  classes={{ root: classes.tableRowCell }}
                >
                  {row.coachStatus}
                </TableCell>
                <TableCell
                  align="left"
                  classes={{ root: classes.tableRowCell }}
                >
                  {row.coachStatus == 'PENDING' ?
                    <div className="d-flex">
                    <Button
                      variant="outlined"
                      //   onClick={() => openAssignCoach(row)}
                      style={{
                        backgroundColor: "#ffffff",
                        color: "#28d604",
                        borderColor: "#28d604",
                        // width: 'max-content'
                      }}
                      disabled={btnPending}
                      onClick={()=>{handleUpdateSatus(row._id, 'APPROVED')}}
                    >
                      <Typography>Approve</Typography>
                    </Button>
                    <Button
                      variant="outlined"
                      style={{
                        borderColor: "#fc7e7e",
                        color: "#fc7e7e",
                        backgroundColor: "#ffffff",
                      }}
                      disabled={btnPending}
                      onClick={()=>{handleUpdateSatus(row._id, 'BLOCKED')}}
                      // onClick={() => {
                      //   handleBlock(row.id, row.name);
                      // }}
                      className="pl-7 pr-8 ml-3"
                    >
                      <Typography>Block</Typography>
                    </Button>
                  </div> 
                  : 
                  <div className="d-flex">
                    <Button
                      variant="outlined"
                      //   onClick={() => openAssignCoach(row)}
                      style={{
                        backgroundColor: "#ffffff",
                        color: "#28d604",
                        borderColor: "#28d604",
                        // width: 'max-content'
                      }}
                      disabled={btnPending}
                      onClick={()=>{handleUpdateSatus(row._id, 'APPROVED')}}
                    >
                      <Typography>Approve</Typography>
                    </Button>
                  </div> 
                  }
                </TableCell>
              </StyledTableRow>
            ))}
          </TableBody>
          :
          <TableBody>
            <TableCell align="center" colSpan={6}>
              <CircularProgress />
            </TableCell>
          </TableBody>
          }
        </Table>
      </TableContainer>
    </div>
  );
}
